/**
 * @file This file contains the audio configuration for the game.
 * @module audioConfig
 */

/**
 * @typedef {Object} AudioConfig
 * @property {Object.<string, string>} sounds - A map of sound names to their file paths.
 */

/**
 * The main audio configuration object.
 * @type {AudioConfig}
 */
export const audioConfig = {
    sounds: {
        'merge': { url: 'assets/sounds/merge.mp3', type: 'foreground' },
        'click': { url: 'assets/sounds/click.mp3', type: 'foreground' },
        'cleaned': { url: 'assets/sounds/sound-effect-twinklesparkle-115095.mp3', type: 'foreground' },
        'dust': { url: 'assets/sounds/broom-sweep-106601.mp3', type: 'foreground' },
        'crate': { url: 'assets/sounds/open-package-box-parcel-100334.mp3', type: 'foreground' },
        'zoo': { url: 'assets/sounds/tada-military-1-183974.mp3', type: 'foreground' },
        'godzilla': { url: 'assets/sounds/monster-growl-390285.mp3', type: 'foreground' },
        'whirlwind': { url: 'assets/sounds/wind-gust-386158.mp3', type: 'foreground' },
        'storm': { url: 'assets/sounds/thunder-strike-wav-321628.mp3', type: 'foreground' },
        'achievement': { url: 'assets/sounds/achievement.mp3', type: 'foreground' },
        'gold': { url: 'assets/sounds/gold.mp3', type: 'foreground' },
        'win': { url: 'assets/sounds/level-complete.mp3', type: 'foreground' },
        'lose': { url: 'assets/sounds/lose.mp3', type: 'foreground' },
        'enter_woodland': { url: 'assets/sounds/enter_woodland.mp3', type: 'background' },
        'enter_jungle': { url: 'assets/sounds/enter_jungle.mp3', type: 'background' },
        'enter_city': { url: 'assets/sounds/enter_city.mp3', type: 'background' },
        'enter_futuristic': { url: 'assets/sounds/enter_futuristic.mp3', type: 'background' },
        'enter_birds': { url: 'assets/sounds/enter_birds.mp3', type: 'background' },
        'play_fight_sound': { url: 'assets/sounds/sword_clash.mp3', type: 'foreground' }, // Placeholder, need to add this sound file
        'npc_chat': {   urls: [
            'assets/sounds/npc (1).mp3',
            'assets/sounds/npc (2).mp3',
            'assets/sounds/npc (3).mp3',
            'assets/sounds/npc (4).mp3',
            'assets/sounds/npc (5).mp3',
            'assets/sounds/npc (6).mp3',
            'assets/sounds/npc (7).mp3',
            'assets/sounds/npc (8).mp3',
            'assets/sounds/npc (9).mp3',
            'assets/sounds/npc (10).mp3',
            'assets/sounds/npc (11).mp3',
            'assets/sounds/npc (12).mp3',
            'assets/sounds/npc (13).mp3'
        ], 
        type: 'foreground',
        effect: 'otherRoom' },
        'level_music': {
            urls: [
                'assets/sounds/level_music (1).mp3',
                'assets/sounds/level_music (2).mp3',
                'assets/sounds/level_music (3).mp3',
                'assets/sounds/level_music (4).mp3',
                'assets/sounds/level_music (5).mp3',
                'assets/sounds/level_music (6).mp3'
                
            ],
            type: 'background'
        }
    }
};